import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/articles";
import type { Article } from "@/mocks/types";

export default function HotRankList() {
  const list = hotArticles.slice(0, 5);
  const medals = ["text-accent-600", "text-secondary-500", "text-accent-700"];
  return (
    <ol className="space-y-1">
      {list.map((a: Article, i) => (
        <li key={a.id}>
          <Link
            to={`/article/${a.id}`}
            className="group flex gap-3 rounded-md px-2 py-3 transition-colors hover:bg-background-100"
          >
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                i < 3
                  ? medals[i]
                  : "bg-secondary-100 text-foreground-600"
              }`}
            >
              {i + 1}
            </span>
            <div className="min-w-0 flex-1">
              <p className="font-heading text-sm font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                <span className="line-clamp-2">{a.title}</span>
              </p>
              <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {a.views}
                </span>
                <span>{a.categoryName}</span>
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ol>
  );
}